export default __webpack_public_path__ + "static/10US-ba3c8f65389312b5c602441a65177430.png";